export default __webpack_public_path__ + "static/media/forest1.b5608ff7.mp3";